import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

@Component({
  selector: 'app-dynamic-banner',
  templateUrl: './dynamic-banner.component.html',
  styleUrls: ['./dynamic-banner.component.sass'],
})
export class DynamicBannerComponent implements OnInit {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() redirectUrl = '';

  constructor() {}

  ngOnInit() {}

  onBannerClick() {
    if (this.redirectUrl) {
      const url = this.redirectUrl.startsWith('http://') || this.redirectUrl.startsWith('https://')
        ? this.redirectUrl
        : 'https://' + this.redirectUrl;
      window.location.href = url;
    }
  }
}
